import { useState } from "react";

const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSc0GZV7QcFrWcGbhLQNWSlNFczWQ-yhevvSQqLFHSJZE9aEBQ/viewform?embedded=true";

export function FeedbackButton() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                className="feedback-fab"
                onClick={() => setIsOpen(true)}
                title="Send feedback"
                aria-label="Send feedback"
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                Feedback
            </button>

            {isOpen && (
                <div className="confirm-modal-overlay" onClick={() => setIsOpen(false)}>
                    <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="feedback-modal-header">
                            <h3 className="confirm-modal-title">Send Feedback</h3>
                            <button
                                className="feedback-modal-close"
                                onClick={() => setIsOpen(false)}
                                aria-label="Close"
                            >
                                ✕
                            </button>
                        </div>
                        <iframe
                            src={GOOGLE_FORM_URL}
                            className="feedback-iframe"
                            title="Feedback form"
                        />
                    </div>
                </div>
            )}
        </>
    );
}
